import { RestApiConfiguration, LegacyApiConfiguration } from './config'
import { PreferencesApi as PreferencesApiGen, RolesApi as RolesApiGen } from './gen/admin'
import { PreferencesApi as PreferencesLegacyApiGen } from './gen/legacy'
import { EntityTypeApi as EntityTypeApiGen } from './gen/admin'
import { StagesAdminApi as StagesAdminApiGen } from './gen/stages'
import { RecurrencesApi as RecurrencesApiGen } from './gen/recurrences'
import { StagesApi as StagesApiGen } from './gen/stages'
import { AssumptionApi as AssumptionApiGen } from './gen/navigator'
import { DeletedRecordsApi as DeletedRecordsApiGen } from './gen/admin'
import { PostEntityCreationRuleApi as PostEntityCreationRuleApiGen } from './gen/admin'
import { ImpersonationApi as ImpersonationApiGen } from './gen/admin'
import { UserExportApi as UserExportApiGen } from './gen/admin'

export const PreferencesLegacyApi = new PreferencesLegacyApiGen(LegacyApiConfiguration)
export const PreferencesApi = new PreferencesApiGen(RestApiConfiguration)
export const RolesApi = new RolesApiGen(RestApiConfiguration)
export const EntityTypeApi = new EntityTypeApiGen(RestApiConfiguration)
export const StagesAdminApi = new StagesAdminApiGen(RestApiConfiguration)
export const RecurrencesApi = new RecurrencesApiGen(RestApiConfiguration)
export const StagesApi = new StagesApiGen(RestApiConfiguration)
export const AssumptionApi = new AssumptionApiGen(RestApiConfiguration)
export const DeletedRecordsApi = new DeletedRecordsApiGen(RestApiConfiguration)
export const PostEntityCreationRuleApi = new PostEntityCreationRuleApiGen(RestApiConfiguration)
export const ImpersonationApi = new ImpersonationApiGen(RestApiConfiguration)
export const UserExportApi = new UserExportApiGen(RestApiConfiguration)
